import Image from 'next/image';

export const Packages = () => {
  const packages = [
    {
      package: 'STANDARD PACKAGE',
      image: '/static/images/cabo/standard-package-cabo.png',
      description: `These rooms are magnificent spaces measuring 495 ft², These spacious, bright rooms are decorated in cheerful colors and feature contemporary furniture. This room is an excellent option for unwinding and relaxing. Standard rooms have a fully equipped, separate bathroom.`,
      prices: {
        single: '$1,300.00',
        double: '$1,800.00',
        triple: '$2,100.00',
      },
      deposit: '$400',
    },
    {
      package: 'DELUXE OCEAN VIEW PACKAGE',
      image: '/static/images/cabo/deluxe-ocean-package.png',
      description: `Are located in the Torre Sol building. They are most popular in the hotel and offer more space for relaxing. They feature a private terrace with open views of both the hotel pool area and the sea with the vantage point. The terrace is perfect for sitting and gazing at the peace of the skyline that meets with the sand and waves beneath. The beautiful palm trees that line the ground level pool area make for a pleasing scenery for guests to enjoy.
      `,
      prices: {
        single: '$1,500.00',
        double: '$2,200.00',
        triple: '$2,500.00',
      },
      deposit: '$600',
    },
    {
      package: 'POOL SIDE PACKAGE',
      image: '/static/images/cabo/3272133.jpeg',
      description: `The Pool Side option measuring 495 ft², also offers guests very spacious bright rooms that are decorated in cheerful colors and feature contemporary furniture. They have a fully equipped, separate bathroom. Similar to the pool view option, the poolside view gives guests the chance to spectate the pool action and pool bar adventure. The difference here is the room is located only steps away from the pool activities. You have convenient and direct access whether you prefer to go for a dip in the sparkling blue pools or relax poolside in one of the comfortable pool chairs. 

`,
      prices: {
        single: '$1,800.00',
        double: '$2,600.00',
        triple: '$2,900.00',
      },
      deposit: '$700',
    },
    {
      package: 'BEACHFRONT VIEW PACKAGE',
      image: '/static/images/BGFAR_ROOM_37.jpeg',
      description: `This serene room features a pretty terrace overlooking the sea. Guests will enjoy the view of the enchanting sandy beach and the dashing waves. It’s the perfect place to spend an afternoon relaxing or listening to the many sounds of the beach front activities.
        `,
      prices: {
        single: '$2,000.00',
        double: '$2,800.00',
        triple: '$3,500.00',
      },
      deposit: '$600',
    },
    {
      package: 'POOL VIEW PACKAGE',
      image: '/static/images/cabo/pool-view-package.png',
      description: `The Pool View option measuring 495 ft², is very spacious with bright rooms decorated in cheerful colors and feature contemporary furniture. They have a fully equipped, separate bathroom. These rooms are great to take advantage of a prime view of the pool activities. If you love watching the pool games and seeing the adventures at the pool bar, this is the room for you. Guests won’t miss any action with the excitement these pool views offer..
        `,
      prices: {
        single: '$1,600.00',
        double: '$2,400.00',
        triple: '$2,700.00',
      },
      deposit: '$700',
    },
  ];
  return (
    <>
      <section className="pt-40 pb-4 w-full h-full px-4">
        <div className="flex items-center justify-center flex-wrap gap-8">
          <Image alt="" width={473} height={83} src="/static/images/cabo/schedule-head-1.png" quality={100} />
          <Image alt="" width={433} height={84} src="/static/images/cabo/schedule-head-2.png" quality={100} />
        </div>
      </section>
      {packages.map((pkg, index) => (
        <section
          key={index}
          className={`text-white bg-[#2B2922] bg-[url('/static/images/cabo/${
            index % 2 === 0 ? 'cabo-gradient-circle.png' : 'cabo-gradient-circle-inverted.png'
          }')] bg-no-repeat bg-contain ${index % 2 === 0 ? 'bg-left' : 'bg-right'} py-24`}>
          <div className="flex flex-col flex-wrap items-center justify-center w-full">
            <div className="w-full border-y border-[#FFFF4E] py-4">
              <div className="flex items-center justify-center gap-1 6 w-full">
                <img src={`/static/images/cabo/${index % 2 === 0 ? 'cabo-sun' : 'cabo-star'}.png`} alt="" />
                <span className="font-solid-grooves text-center text-4xl text-white ">{pkg.package}</span>
                <img src={`/static/images/cabo/${index % 2 === 0 ? 'cabo-sun' : 'cabo-star'}.png`} alt="" />
              </div>
            </div>
          </div>
          <div
            className={`flex flex-wrap gap-6 sm:gap-24 px-4 justify-center container mx-auto mt-6 ${
              index % 2 === 0 ? 'flex-row-reverse' : ''
            }`}>
            <Image alt="" width={530} height={375} src={pkg.image} quality={100} />
            <div className="flex flex-col gap-4">
              <p className="text-left text-lg max-w-[460px]">{pkg.description}</p>
              <div className="font-bold">
                <p>Single Guest {pkg.prices.single}</p>
                <p>Double {pkg.prices.double}</p>
                <p>Triple {pkg.prices.triple}</p>
              </div>
              <a
                href="https://www.wetravel.com/trips/beyound-borders-j-b-entertainment-cabo-san-lucas-65500526"
                className="bg-gradient-to-b from-[#FF8] to-[#FF0] text-[#2B2922] font-bold rounded-full shadow-inner sm:max-w-[245px] px-8 py-2"
                style={{
                  borderRadius: '64px',
                  boxShadow: '0px 4px 4px 0px rgba(255, 255, 255, 0.25) inset',
                }}>
                DEPOSIT - {pkg.deposit}
              </a>
            </div>
          </div>
        </section>
      ))}
    </>
  );
};
